import { Image } from './image.model';

export class Agency {
  uuid: string;
  address: string;
  city_name: string;
  county_name: string;
  logo: Image;
  map_plan: Image;
  email: string;
  facebook_link: string;
  instagram_link: string;
  pinterest_link: string;
  vimeo_link: string;
  youtube_link: string;
  gplus_link: string;
  latitude: number;
  longitude: number;
  name: string;
  phone: string;
  web_page_types: string[] = [];
  social_header_visibility: boolean;
  social_footer_visibility: boolean;
}



// WEBPACK FOOTER //
// ./src/app/common-theme/models/agency.model.ts